"use strict";

const buildInvoiceVerificationPath = ({
  invoiceNumber,
  verificationToken,
} = {}) => {
  const safeToken = String(verificationToken || "").trim();
  if (safeToken) {
    if (!/^[a-f0-9]{64}$/i.test(safeToken)) {
      return "";
    }
    return `/verify/invoice/v/${encodeURIComponent(safeToken)}`;
  }

  const safeInvoiceNumber = String(invoiceNumber || "").trim();
  if (!safeInvoiceNumber) {
    return "";
  }

  // Compatibilite avec les QR deja imprimes. Les nouveaux documents doivent
  // toujours fournir verificationToken afin d'eviter toute resolution ambigue.
  return `/verify/invoice/${encodeURIComponent(safeInvoiceNumber)}`;
};

const buildInvoiceVerificationUrl = ({
  baseUrl,
  invoiceNumber,
  verificationToken,
} = {}) => {
  const path = buildInvoiceVerificationPath({
    invoiceNumber,
    verificationToken,
  });
  if (!path) return "";

  return `${String(baseUrl || "").trim().replace(/\/$/, "")}${path}`;
};

const buildSubscriptionInvoiceVerificationUrl = ({
  baseUrl,
  verificationToken,
} = {}) => {
  const safeToken = String(verificationToken || "").trim();
  if (!/^[a-f0-9]{64}$/i.test(safeToken)) return "";

  return `${String(baseUrl || "").trim().replace(/\/$/, "")}/verify/subscription/invoice/v/${encodeURIComponent(safeToken)}`;
};

module.exports = {
  buildInvoiceVerificationPath,
  buildInvoiceVerificationUrl,
  buildSubscriptionInvoiceVerificationUrl,
};
